import React from "react";
import { RouterProvider } from "react-router-dom";
import {
  CookieConsentBanner,
  CookieConsentProvider,
} from "../components/cookieConsent";
import { router } from "../routes/routes";

// import { PrivacyPolicy } from "./privacyPolicy";
export const Main = () => {
  return (
    <CookieConsentProvider>
      <RouterProvider router={router} />
      <CookieConsentBanner />
    </CookieConsentProvider>
  );
};
